<template>
    <div>
         <!-- 头部 -->
       <top></top>
       <div class="main">
            <navMenu :active="active"></navMenu>
            <div class="content" v-loading.fullscreen.lock="loading">
               <div class="title_box">
                   <div class="title">未来营养超市活动简介</div>
                   <div class="go-back" @click="goback">返回首页</div>
               </div>
                <div class="dis-notice">
                        <!--<p>评奖说明：</p>-->
                        <p>11月20-22日，NHNE中国国际健康营养博览会将在武汉国际博览中心举办，作为行业旗舰展会，为了应对市场变化，提升展会实效，展会同期将举办健康买手采购节和未来营养超市活动，精心筛选超过10000款商品中的佼佼者，依据人群特性与功能场景细分，呈现最具代表性的趋势新品与爆品，
                            通过场景化展示结合互动体验，吸引1000+终端采购商、私域渠道、网红达人等前来选品对接，帮助企业有效激活存量渠道开拓新渠道，精准触达目标消费者。此次盛会不仅是一场行业交流的盛宴，更是企业市场破局的关键一跃。
                        </p>
                        <!--<p>2. 仅针对申报产品奖企业，报名成功后，请同步邮寄相应产品三份至主办方处<br>-->
        <!--（邮寄地址：北京市朝阳区新源南路1-3号平安国际金融中心B座15层，田先生 18611347915），并注明物品信息。</p>-->
                        <!--<p>* 样品仅作为参选材料真实性查验及现场评选之依据，请务必确保参评产品无安全风险</p>-->
                        <!--<p>4. 本次评选活动最终解释权归NHNE中国国际健康营养博览会主办方国药励展展览有限责任公司所有</p>-->
                        <!--<p>5. <span class="red">报名截止时间2024年4月12日</span></p>-->
                        <div class="pdf_box_content">
                            <div class="pdf_box">
                                <img src="../../assets/discussion/pdf_icon.jpg">
                                <div class="txt_box">
                                    <div class="txt_title">未来营养超市报名操作手册.pdf</div>
                                    <div class="txt_size" style="width:auto;">请在报名前下载并阅读</div>
                                </div>
                                <div class="xz_btn" @click="loaddown">下载</div>
                            </div>
                            <div class="pdf_box">
                                <img src="../../assets/discussion/pdf_icon.jpg">
                                <div class="txt_box">
                                    <div class="txt_title">货架好物报名操作手册.pdf</div>
                                    <div class="txt_size" style="width:auto;">请在报名前下载并阅读</div>
                                </div>
                                <div class="xz_btn" @click="loaddownhj">下载</div>
                            </div>
                        </div>
                        <p class="seek">咨询热线：国药励展 田野 010-84556504  /  18611347915（微信同）</p>
                        <p class="tipsa">
                            注意：“货架好物”活动报名成后，请邮寄样品10份用于现场展示（请发空包装产品，实物产品主办方将统一处理不再寄回）。快递外包装清注明“NHNE未来营养超市+公司名称+产品名称”邮寄地址（2024年11月1日前发出快递）：北京市朝阳区新源南路1-3号平安国际金融中心B座15层，魏琳青，18810390013
                        </p>
                </div>
                <!--奖项列表-->
                <div class="dis-list flex flex-wrap">
                    <div class="dis-item flex-center-btw" v-for="(item, index) in list" :key="index">
                        <!-- <div class="sign-tips" v-if="item.is_report > 0">已报名</div> -->
                        <div class="dis-item-left">
                            <div class="dis-title">{{item.name}}</div>
                            <div class="dis-time">截止时间：{{item.reg_endtime_new}}</div>
                            <!--<div class="dis-more" @click="viewsdetail"><a>查看详情 <img class="more-img" mode="widthFix" src="../../assets/discussion/dis_more.jpg" ></a></div>-->
                        </div>
                        <div class="dis-item-right">
                            <!-- <a v-if="item.type == '1' && item.is_report > 0" ><div class="dis-btn dis-ebtn">修改</div></a>
                            <a v-else-if="item.type == '2' && item.is_report > 0" ><div class="dis-btn dis-ebtn">修改/更换</div></a> -->
                            <div class="dis-btn end" v-if="item.timestatus==0">报名未开始</div>
                            <div class="dis-btn end"  v-if="item.timestatus==1">报名已结束</div>
                            <div  @click="register(item)" v-if="item.timestatus==2" class="dis-btn">立即报名</div>
                        </div>
                    </div>
                </div>
            </div>

           <el-dialog
                   title=""
                   :visible.sync="dialogVisible"
                   width="30%"
                   :before-close="handleClose">
               <span class="statustips">{{statustips}}</span>
               <span slot="footer" class="dialog-footer" >

                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
              </span>
           </el-dialog>

       </div>
    </div>
</template>

<script>
import {nhneMarketAwardslists,getPurview} from "@/api/api";
import '../../style/base.css'
import top from "../../components/top.vue"; //头部
import navMenu from "../../components/navMenu.vue"; //左侧步骤条
import moment from 'moment'
 export default {
    name:'discussionindex',
    components: { top, navMenu },
    data(){
        return{
            dialogVisible:false,
            statustips:'',
            status:'',
            page: 1,
            pagesize: 8,
            total: 0, // 总条目数，需要根据实际情况设置
            Imghttp:'https://oss.larspring.com/pharmchina',
		    list:[
                // {
                //     "id": "1",
                //     "name": "品牌企业奖",
                //     "type": "1",
                //     "reg_starttime": "1710259200",
                //     "reg_endtime": "1712937600",
                //     "enddate": "2024年04月13日",
                //     "startdate": "2024年03月13日",
                //     "url": "/user.php?m=discussion.enterpriseAward",
                //     'url_name':'productawardList',
                //     "is_report": "0"
                // },
                // {
                //     "id": "2",
                //     "name": "产品奖",
                //     "type": "2",
                //     "reg_starttime": "1710259200",
                //     "reg_endtime": "1776009600",
                //     "enddate": "2026年04月13日",
                //     "startdate": "2024年03月13日",
                //     "url": "/user.php?m=discussion.productawardList",
                //     'url_name':'productawardList',
                //     "is_report": "0"
                // }
            ]
        }
    },
    mounted() {
            /* 2024.8.15 基础版本备份 */
            // 获取活动类型
            this.getList();

                
        },
    methods: {
        goback(){
            this.$router.push({
                path: "/index",
            });
        },
        getList(){
            let data = {};
            nhneMarketAwardslists({}).then(res=>{
                    if(res.data.code==1){
                        this.list=res.data.data.lists;
                        this.list.map(item=>{
                            item.reg_endtime_new=moment(item.reg_endtime, 'YYYY-MM-DD').format("YYYY年MM月DD日")
                            console.log(item.reg_endtime_new,"item.reg_endtime_new")
                            item.url_name='productawardList'
                               // //开始时间戳
                        let reg_starttime = item.reg_starttime;
                        let reg_endtime = item.reg_endtime;
                        //当前时间戳
                        let timestamp = Date.now() / 1000;
                        //如果开始时间戳小于当前时间戳 跳转到奖项填写页面 否则弹出提示信息
                        if(reg_starttime < timestamp){
                            item.timestatus=0
                        }else if(reg_endtime < timestamp){
                            item.timestatus=1
                        }else{
                            item.timestatus=2
                        }
                        })
                        console.log(res.data.data.lists)
                    }else{
                        this.$message.error(res.data.msg) 
                    }

                }).catch(err=>{
                    console.log(err)
                })
            },
       
            /* 2024.8.15 基础版本备份 */
			// 获取奖项列表
            // getList(){
            //     // axios.get('api.php?m=awards.infoList&v=3.0',{}).then(res => {
            //     //             //console.log(res, '---获取奖项列表');
            //     //             if(res.status == 200){
            //     //                 let data = res.data.rst;
            //     //                 this.list = data.list;
            //     //             }
            //     //         }).catch(function (err) { 
            //     //             //console.log(err);
            //     //         });   
            // },
            //立即报名
            register(item){
                // //开始时间戳
                // let startime = item.reg_starttime;
                // //当前时间戳
                // let timestamp = Date.now() / 1000;
                // //如果开始时间戳小于当前时间戳 跳转到奖项填写页面 否则弹出提示信息
                // if(startime < timestamp){
                //     window.location.href=`${item.url}&id=${item.id}&report=${item.is_report}`;
                // }else{
                //     this.$message.warning(`暂未开始,报名开始时间${item.startdate}`);
                // }
                if(item.id==2){
                    this.getPurviewdata(item)

                }else{
                    sessionStorage.setItem("itemdata",JSON.stringify(item))
                    if(item.link_type==1){//内链
                        this.$router.push({
                            name:item.url_name,
                        })
                    }else if(item.link_type==2){//外链
                        let winOpen = window.open("", "_blank"); //首先打开一个新页面
                        setTimeout(() => {winOpen.location = item.link_url}, 100)

                    }

                }


                // this.$router.push({
                //     name:item.url_name,
                // })
            },
        getPurviewdata(item){
            getPurview({}).then(res=>{
                if(res.data.code==1){
                    this.status=res.data.data.status;
                    if(res.data.data.status=='abnormal'){
                       this.dialogVisible=true;
                       this.statustips=res.data.msg;

                    }else if(res.data.data.status=='normal'){
                        sessionStorage.setItem("itemdata",JSON.stringify(item))
                        if(item.link_type==1){//内链
                            this.$router.push({
                                name:item.url_name,
                            })
                        }else if(item.link_type==2){//外链
                            let winOpen = window.open("", "_blank"); //首先打开一个新页面
                            setTimeout(() => {winOpen.location = item.link_url}, 100)
                        }

                    }


                }

            }).catch(err=>{
                console.log(err)
            })

        },
            // 下载pdf
            loaddown(){
                let url="https://oss.larspring.com/pharmchina/var/upload/file/2024/08/%E6%9C%AA%E6%9D%A5%E8%90%A5%E5%85%BB%E8%B6%85%E5%B8%82.pdf"
                window.open(url, "_blank");
            },
            loaddownhj(){
                let url="https://oss.larspring.com/pharmchina/upload/pdf/%E8%B4%A7%E6%9E%B6%E5%A5%BD%E7%89%A9%E6%8A%A5%E5%90%8D%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf"
                window.open(url, "_blank");
            },
            // 查看详情
            viewsdetail(){
                this.$router.push({
                    name:'awardsDetail'
               });
            }
		}
 }
</script>

<style scoped>
    .title_box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .go-back{
        width: 148px;
        height: 42px;
        color: #999;
        line-height: 42px;
        text-align: center;
        font-size: 19px;
        font-weight: 500;
        background: #FFF;
        cursor: pointer;
        border-radius: 4px;
        border: 1px solid #CECECE;
    }
    .pdf_box_content{
        display: flex;
    }
    .pdf_box{
        margin-right: 15px;
    }

   .end{
        background: #C8CBD3 !important;
        border: 1px solid #C8CBD3 !important;
    }
/* 2024.8.15 基础版本备份 */
.content{
    background: #fff !important;
    margin-right: 40px !important;
}
/*评奖报名首页*/
.main{
    padding: 30px 0px 30px 40px;
    box-sizing: border-box;
}
.main .title{
    color: #000;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    font-family: SourceHanSansCN, SourceHanSansCN;
}
.main .dis-notice{
    color: #000;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 22px;
    border-radius: 8px;
    background: #F8F8F8;
    margin: 20px 0 52px;
    font-family: PingFangSC, PingFang SC;
}
.main .dis-notice p{
    max-width: 730px;
}
.main .dis-notice .seek{
    font-size: 16px;
    line-height: 24px;
    padding-top: 15px;
}
.main .dis-list .dis-item{
    width: 44%;
    height: 162px;
    max-width: 510px;
    min-width: 430px;
    margin-right: 30px;
    margin-bottom: 30px;
    background: #F6F7FC;
    border-radius: 8px;
    padding: 31px 20px 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    position: relative;
    font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-left .dis-title{
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
}
.main .dis-list .dis-item-left .dis-time{
    font-size: 20px;
    padding: 15px 0;
    line-height: 28px;
}
.main .dis-list .dis-item-left .dis-more a{
    color: #999;
    display: flex;
    align-items: center;
}
.main .dis-list .dis-item-left .dis-more .more-img{
    width: 17px;
}
.main .dis-list .dis-item .sign-tips{
    width: 116px;
    height: 39px;
    color: #FF0000;
    font-size: 18px;
    text-align: center;
    line-height: 39px;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient( 180deg, rgba(255,0,0,0) 0%, rgba(255,0,0,0.2) 100%);
    border-radius: 8px 8px 8px 26px;
}
.main .dis-list .dis-item-right .dis-btn{
    width: 128px;
    height: 44px;
    color: #FFF;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    line-height: 44px;
    text-align: center;
    background: #FC9749;
    border-radius: 8px;
    border: 1px solid #FC9749;
    font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-right .dis-ebtn{
    color: #FC9749;
    background: #FFF;
    border: 1px solid #FC9749;
}
.tipsa{
    color: red;
    margin-top: 10px;
}

.pdf_box{
    width: 358px;
    height: 68px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
}
.pdf_box img{
    width: 28px;
    height: 28px;
}
.txt_box{
    margin: 0 58px 0 10px;
}
.txt_title{
    width: 184px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #000000;
    line-height: 24px;
}
.txt_size{
    width: 39px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 24px;
}
.xz_btn{
    width: 54px;
    height: 26px;
    line-height: 26px;
    background: #E4EFFF;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #3D83E9;
    text-align: center;
    cursor: pointer;
}
.statustips{
    font-size: 16px;
    font-weight: 900;
}
   @media only screen and (max-width: 767px) {
       .main{
           width: 96%;
           padding: 5px 0 15px  0px;
       }
        .main .dis-list .dis-item{
            width: 100%;
            min-width: 318px;
            margin-right: 30px;
            margin-bottom: 30px;
            background: #F6F7FC;
            border-radius: 8px;
            padding: 31px 20px 20px;
            box-sizing: border-box;
            font-size: 14px;
            color: #000;
            line-height: 20px;
            position: relative;
            font-family: PingFangSC, PingFang SC;
        }
        .txt_box{
            margin: 0 18px 0 10px;
        }
       .main .dis-notice{
           padding: 15px;
       }
       .pdf_box{
          width: 290px;
           padding: 0px 10px;
       }
       .content {
           width: 96%;
           padding: 20px 21px 110px 20px
       }
       .main .dis-list .dis-item-left .dis-title {
           font-size: 20px;
       }

       .main .dis-list .dis-item-left .dis-time{
           font-size: 16px;
           padding: 5px 0;

  }
       .dis-btn{
           width: 90px !important;
           height: 34px !important;
           line-height: 34px !important;
           font-size: 14px !important;
       }
   }


</style>